// src/formatDuration.ts
var zeroPad = (number, maxLength = 2) => {
  return String(number).padStart(maxLength, "0");
};
var formatDuration = (milliseconds) => {
  const hours = Math.floor(milliseconds / (60 * 60 * 1e3)) % 24;
  const minutes = Math.floor(milliseconds / (60 * 1e3)) % 60;
  const seconds = Math.floor(milliseconds / 1e3) % 60;
  let formatted = "";
  if (hours > 0) {
    formatted += `${hours}:${zeroPad(minutes)}:`;
  } else {
    formatted += `${minutes}:`;
  }
  formatted += zeroPad(seconds);
  return formatted;
};

// ../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

// ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}

// ../../node_modules/date-fns/esm/toDate/index.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

// ../../node_modules/date-fns/esm/addDays/index.js
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

// ../../node_modules/date-fns/esm/startOfDay/index.js
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js
var MILLISECONDS_IN_DAY = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

// ../../node_modules/date-fns/esm/isSameDay/index.js
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

// ../../node_modules/date-fns/esm/differenceInDays/index.js
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}

// ../../node_modules/date-fns/esm/fromUnixTime/index.js
function fromUnixTime(dirtyUnixTime) {
  requiredArgs(1, arguments);
  var unixTime = toInteger(dirtyUnixTime);
  return toDate(unixTime * 1e3);
}

// ../../node_modules/date-fns/esm/intlFormat/index.js
function intlFormat(date, formatOrLocale, localeOptions) {
  var _localeOptions;
  requiredArgs(1, arguments);
  var formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}
function isFormatOptions(opts) {
  return opts !== void 0 && !("locale" in opts);
}

// ../../node_modules/date-fns/esm/startOfHour/index.js
function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/isSameHour/index.js
function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

// ../../node_modules/date-fns/esm/isSameYear/index.js
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

// ../../node_modules/date-fns/esm/isThisHour/index.js
function isThisHour(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameHour(Date.now(), dirtyDate);
}

// ../../node_modules/date-fns/esm/isThisYear/index.js
function isThisYear(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameYear(dirtyDate, Date.now());
}

// ../../node_modules/date-fns/esm/isToday/index.js
function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}

// ../../node_modules/date-fns/esm/isTomorrow/index.js
function isTomorrow(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, addDays(Date.now(), 1));
}

// ../../node_modules/date-fns/esm/subDays/index.js
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

// ../../node_modules/date-fns/esm/isYesterday/index.js
function isYesterday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, subDays(Date.now(), 1));
}

// src/i18n.ts
var translations = {
  nb: {
    yesterday: "i g\xE5r",
    today: "i dag",
    tomorrow: "i morgen"
  },
  sv: {
    yesterday: "i g\xE5r",
    today: "i dag",
    tomorrow: "i morgon"
  }
};
var t = (key, locale) => {
  return translations[locale][key];
};

// src/formatPublishedDate.ts
var isRelativeTimeFormatSupported = "RelativeTimeFormat" in Intl;
var formatHourDistance = (date, locale) => {
  const differenceInMinutes = Math.ceil((date.getTime() - Date.now()) / (60 * 1e3));
  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: "auto",
    style: "short"
  });
  return rtf.format(differenceInMinutes, "minute");
};
var formatPublishedDate = (timestamp, locale) => {
  const date = fromUnixTime(timestamp);
  const localeOptions = { locale };
  if (isThisHour(date) && isRelativeTimeFormatSupported) {
    return formatHourDistance(date, locale);
  }
  if (isToday(date)) {
    return `${t("today", locale)} ${intlFormat(
      date,
      {
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    )}`;
  }
  if (isYesterday(date)) {
    return `${t("yesterday", locale)} ${intlFormat(
      date,
      {
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    )}`;
  }
  if (isThisYear(date)) {
    return intlFormat(
      date,
      {
        month: "long",
        day: "numeric"
      },
      localeOptions
    );
  }
  return intlFormat(
    date,
    {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    localeOptions
  );
};

// src/formatUpcomingDate.ts
var formatUpcomingDate = ({
  timestamp,
  locale,
  streamType
}) => {
  const date = fromUnixTime(timestamp);
  const localeOptions = { locale };
  if (isToday(date)) {
    return `${t("today", locale)} ${intlFormat(
      date,
      {
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    )}`;
  }
  if (isTomorrow(date)) {
    return `${t("tomorrow", locale)} ${intlFormat(
      date,
      {
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    )}`;
  }
  const diff = differenceInDays(date, Date.now());
  if (diff < 7) {
    return intlFormat(
      date,
      {
        weekday: "long",
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    );
  }
  if (streamType === "live" && diff < 31) {
    return intlFormat(
      date,
      {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      },
      localeOptions
    );
  }
  if (isThisYear(date)) {
    return intlFormat(
      date,
      {
        month: "long",
        day: "numeric"
      },
      localeOptions
    );
  }
  return intlFormat(
    date,
    {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    localeOptions
  );
};
export {
  formatDuration,
  formatPublishedDate,
  formatUpcomingDate
};
